import { Component, Input } from '@angular/core'
import { ScopeVersion } from '@app/core/model/scope-version'
import { Store } from '@ngrx/store'
import { filter, Observable, take } from 'rxjs'
import { ScopeOverviewSelectors } from '@app/features/scope-overview/store/selectors/scope-overview.selector'
import { ScopeDetailsService } from '@app/features/scope-overview/service/scope-details.service'
import { SowRetainedTeamStats } from '@app/features/scope-overview/model/sow-retained-team-stats.model'
import { UserSettingsService } from '@app/features/scope-overview/service/user-settings.service'
import { MatDialog } from '@angular/material/dialog'
import { ScopeUiModalComponent } from '@app/shared/components/ui-components/scope-ui-modal/scope-ui-modal.component'
import { ModalConfig } from '@app/core/model/modal-config.model'
import { ScopeOverviewActions } from '@app/features/scope-overview/store/actions/scope-overview.action'
import { ScopeCustomFieldValueStructure } from '@app/features/scope-overview/model/scope-custom-field-value-structure.model'
import { SNACKBAR_LENGTH_SHORT, SnackbarEventType, SnackbarService } from '@app/shared/utils/snackbar.service'
import { LanguageService } from '@app/core/service/language.service'

@Component({ selector: 'scope-details-container', templateUrl: './scope-details-container.component.html' })
export class ScopeDetailsContainerComponent {
  @Input() id: number

  isUpdateLoading$: Observable<boolean> = this.store$.select(ScopeOverviewSelectors.selectUpdateScopeDetailsLoading)
  currentScope$: Observable<ScopeVersion> = this.store$.select(ScopeOverviewSelectors.selectCurrentScope)
  sowRetainedTeamStats$: Observable<SowRetainedTeamStats[]> = this.store$.select(
    ScopeOverviewSelectors.selectRetainedTeamStats
  )

  constructor(
    private store$: Store,
    private dialog: MatDialog,
    private lang: LanguageService,
    private snackbarService: SnackbarService,
    protected scopeDetailsService: ScopeDetailsService,
    protected userSettingsService: UserSettingsService
  ) {}

  confirmMetaStructureUpdate = (currentScope: ScopeVersion) => {
    const dialog = this.dialog.open(ScopeUiModalComponent, {
      data: new ModalConfig(
        `Confirm the update of the company custom fields`,
        `The custom fields will be updated, proceed?`,
        'Confirm',
        'Cancel',
        () => {
          dialog.close()
          this.store$.dispatch(
            ScopeOverviewActions.refreshOutdatedCustomFields({
              scopeId: this.id,
              customFieldValueStructure:
                currentScope.scopeVersionCustomFieldValueStructure || new ScopeCustomFieldValueStructure(),
            })
          )
        },
        undefined
      ),
    })
  }

  saveDetails(scope: ScopeVersion) {
    this.store$.dispatch(ScopeOverviewActions.updateScope({ scope }))
    this.store$
      .select(ScopeOverviewSelectors.selectUpdateScopeDetailsLoaded)
      .pipe(
        filter((response) => !!response),
        take(1)
      )
      .subscribe(() => {
        this.snackbarService.showSnackbar(
          `${this.lang.get('scope')} successfully updated`,
          SNACKBAR_LENGTH_SHORT,
          SnackbarEventType.SUCCESS
        )
      })
  }
}
